import React from "react";
import { Plus, Check } from "lucide-react";
import { useRegistry } from "@/context/RegistryContext";
import { DASHBOARD } from "@/constants/testIds";

export const MarketplaceCard = ({ item }) => {
  const { addItem, removeItem, isInRegistry } = useRegistry();
  const added = isInRegistry(item.id);

  const eyebrow = item.format ? `${item.tag}  ·  ${item.format}` : item.tag;

  return (
    <article
      data-testid={DASHBOARD.marketplaceCard(item.id)}
      className="group bg-[#FDFBF7] border border-[#E5E1D8] rounded-3xl overflow-hidden card-lift flex flex-col"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-[#F4F1EA]">
        <img
          src={item.image}
          alt={item.title}
          className="w-full h-full object-cover scale-[1.08] transition-transform duration-[900ms] group-hover:scale-[1.14]"
        />
      </div>

      <div className="p-6 flex flex-col flex-1">
        <p className="text-[11px] tracking-[0.14em] text-[#5C6B62] leading-relaxed">
          {eyebrow}
        </p>
        <h3 className="font-display text-xl text-[#2D3732] mt-2 leading-snug">
          {item.title}
        </h3>
        <p className="mt-3 text-sm text-[#5C6B62] leading-relaxed line-clamp-3">
          {item.description}
        </p>

        <div className="mt-6 pt-5 border-t border-[#E5E1D8] flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:justify-end">
          {added ? (
            <button
              data-testid={DASHBOARD.removeBtn(item.id)}
              onClick={() => removeItem(item.id)}
              className="w-full sm:w-auto rounded-full border border-[#A3B19B] text-[#A3B19B] px-5 py-2.5 text-xs font-medium inline-flex items-center justify-center gap-1.5 hover:bg-[#A3B19B] hover:text-[#FDFBF7] transition-colors"
            >
              <Check size={14} strokeWidth={2} />
              On her wishlist
            </button>
          ) : (
            <button
              data-testid={DASHBOARD.addBtn(item.id)}
              onClick={() => addItem(item)}
              className="w-full sm:w-auto rounded-full bg-[#2D3732] text-[#FDFBF7] px-5 py-2.5 text-xs font-medium inline-flex items-center justify-center gap-1.5 hover:bg-[#D98A71] transition-colors"
            >
              <Plus size={14} strokeWidth={2} />
              Add to My Wishlist
            </button>
          )}
        </div>
      </div>
    </article>
  );
};
